import { ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface WarningDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  actions: ReactNode;
  stackedActions?: boolean;
}

function WarningDialog({ open, onClose, title, message, actions, stackedActions = false }: WarningDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <WarningAmberIcon sx={{ color: 'warning.main' }} />
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '0.9rem', color: 'text.primary' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        disableSpacing={stackedActions}
        sx={{ px: 3, pb: 2.5, pt: 0, ...(stackedActions && { rowGap: 1, flexDirection: 'column', alignItems: 'stretch' }) }}
      >
        {actions}
      </DialogActions>
    </Dialog>
  );
}

export default WarningDialog;
